const PrivacyPolicy = () => {
 const privacyData = [
  {
    title: "Introduction",
    description: "At Tenafix, we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard information from landlords, tenants, and users."
  },
  {
    title: "Information We Collect",
    description: "Landlords: Name, contact details, payout details, property and tenant records.\nTenants: Name, contact details (if provided), unique payment code, payment history.\nTransactions: Payment amounts, dates, and confirmation references (processed securely via Relworx)."
  },
  {
    title: "How We Use Information",
    description: "To process rent payments and transfer funds to landlords.\nTo generate receipts, reminders, and property reports.\nTo comply with Ugandan financial and tax regulations.\nTo improve and customize our services."
  },
  {
    title: "Data Sharing",
    description: "We only share data with:\nPayment Gateway Providers (e.g., Relworx): To process payments securely.\nService Partners (legal, tax, maintenance): Only when requested by landlords.\nRegulatory Authorities: When required by law.\nWe do not sell or rent user information to third parties."
  },
  {
    title: "Data Security",
    description: "Payments and sensitive data are encrypted and transmitted securely.\nUser data is stored in secure systems with restricted access.\nRegular monitoring helps prevent unauthorized access."
  },
  {
    title: "User Rights",
    description: "You may:\nRequest access to your personal data.\nRequest corrections of inaccurate data.\nRequest deletion of your data, subject to legal and financial obligations."
  },
  {
    title: "Data Retention",
    description: "We retain transaction and account records for a minimum of five (5) years in compliance with Ugandan laws."
  },
  {
    title: "Updates",
    description: "We may update this Privacy Policy as services evolve. Significant changes will be communicated via the platform or email."
  }
];

  return (
    <div className="px-4 md:px-8 lg:px-[120px]">
      <div className="h-20 md:h-32 lg:h-[136px] bg-[#F6F5FF] flex justify-center items-center">
        <h1 className="mt-0 font-semibold font-Alexandria text-2xl md:text-4xl lg:text-[46px] text-center text-[#071952]">
          Privacy Policy
        </h1>
      </div>

      <div className="px-4 md:px-6 lg:px-[24px] mt-8 md:mt-12 lg:mt-[52px] pb-4 md:pb-6 lg:pb-[20px] space-y-3 md:space-y-4 lg:space-y-[15px]">
        <div>
          
          <p className="font-poppins text-sm md:text-[15px] text-[#494949]">
            Effective Date: 2025-09-25
          </p>
          <p className="font-poppins text-sm md:text-[15px] text-[#494949]">
            Company: Tenafix Limited ("Tenafix", "we", "our", "us")
          </p>
        </div>
      </div>

      <div className="px-4 md:px-6 lg:px-[24px] mb-16 md:mb-24 lg:mb-[120px]">
        {privacyData.map((term, index) => (
          <div key={index} className="mt-6 md:mt-8 lg:mt-[24px]">
            <h2 className="font-poppins mb-4 md:mb-5 lg:mb-[20px] text-lg font-semibold">{term.title}</h2>
            {term.description.split('\n').map((paragraph, pIndex) => (
              <p key={pIndex} className="font-poppins text-sm md:text-[15px] text-[#494949]">
                {paragraph}
              </p>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PrivacyPolicy;